import React__default, { useRef } from 'react';
import { useSocketIOContext } from './useSocketIOContext.js';

const useSocketIOEventListener = (event, cb, options) => {
  const enabled = options?.enabled ?? true;
  const { socket } = useSocketIOContext();
  const cbRef = useRef(cb);
  cbRef.current = cb;
  React__default.useEffect(() => {
    if (enabled) {
      const attachFn = cbRef.current;
      socket?.on(event, attachFn);
      return () => {
        socket?.off(event, attachFn);
      };
    }
  }, [
    socket,
    event,
    enabled
  ]);
};

export { useSocketIOEventListener };
//# sourceMappingURL=useSocketIOEventListener.js.map
